import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
import DialogContext from './DialogContext';

var DialogBody = function DialogBody(_ref) {
  var children = _ref.children,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var dialog = React.useContext(DialogContext);
  var rootStyles = /*#__PURE__*/css({
    flex: dialog.scrollable ? '1 1 auto' : undefined,
    padding: '0.5rem 1rem',
    overflowY: dialog.scrollable ? 'auto' : undefined
  }, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0RpYWxvZ0JvZHkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWFxQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9EaWFsb2dCb2R5LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuXG5pbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgRGlhbG9nQ29udGV4dCBmcm9tICcuL0RpYWxvZ0NvbnRleHQnO1xuaW1wb3J0IHR5cGUgeyBEaWFsb2dCb2R5UHJvcHMgfSBmcm9tICcuLi90eXBlcyc7XG5cbmNvbnN0IERpYWxvZ0JvZHk6IFJlYWN0LkZDPERpYWxvZ0JvZHlQcm9wcz4gPSAoe1xuICBjaGlsZHJlbixcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pID0+IHtcbiAgY29uc3QgZGlhbG9nID0gUmVhY3QudXNlQ29udGV4dChEaWFsb2dDb250ZXh0KTtcblxuICBjb25zdCByb290U3R5bGVzID0gY3NzKHtcbiAgICBmbGV4OiBkaWFsb2cuc2Nyb2xsYWJsZSA/ICcxIDEgYXV0bycgOiB1bmRlZmluZWQsXG4gICAgcGFkZGluZzogJzAuNXJlbSAxcmVtJyxcbiAgICBvdmVyZmxvd1k6IGRpYWxvZy5zY3JvbGxhYmxlID8gJ2F1dG8nIDogdW5kZWZpbmVkLFxuICB9KTtcblxuICByZXR1cm4gKFxuICAgIDxkaXYgey4uLnVuaGFuZGxlZFByb3BzfSBjc3M9e3Jvb3RTdHlsZXN9PlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvZGl2PlxuICApO1xufTtcblxuRGlhbG9nQm9keS5kaXNwbGF5TmFtZSA9ICdEaWFsb2dCb2R5JztcblxuZXhwb3J0IGRlZmF1bHQgRGlhbG9nQm9keTtcbiJdfQ== */");
  return jsx("div", _extends({}, unhandledProps, {
    css: rootStyles
  }), children);
};

DialogBody.displayName = 'DialogBody';
export default DialogBody;